export const jurisTypes = [
  { label: 'Todos', value: 'todos' },
  { label: 'Súmulas', value: 'sumula' },
  { label: 'Acórdãos', value: 'acordao' },
  { label: 'Decisões', value: 'decisao' },
  { label: 'Sentenças', value: 'sentenca' },
  { label: 'Despachos', value: 'despacho' },
  { label: 'Orientações Jurisprudenciais', value: 'orientacao_jurisprudencial' },
]

export const jurisTypesMap = jurisTypes.reduce(
  (acc, { label, value }) => acc.set(value.toLowerCase(), { label }),
  new Map()
)
